import {useContext} from 'react';

import ReportParametersContext from '../../contexts/ReportParametersContext';

const useReportParameters = () => {
  return useContext(ReportParametersContext);
};

export default useReportParameters;
